import { AskDataIndexing } from '~src/ts/models/IDataSourceInfo';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ISetDatasourceAskDataSettingsParams {
  id: number;
  indexing: AskDataIndexing;
  // TODO: (TFS 1232810) make it required when NLFeedbackToCurator flag is removed
  feedbackToCuratorEnabled?: boolean;
}

export class SetDatasourceAskDataSettingsRequest extends Request<ISetDatasourceAskDataSettingsParams, IEmptyResult> {
  constructor(params: ISetDatasourceAskDataSettingsParams) {
    super('setDatasourceAskDataSettings', params);
  }
}
